<template>
  <div class="design-nature">
    <div class="hero-wrap">
      <img :src="heroImage" alt="" class="hero-wrap__bg" />
      <div class="hero-wrap__shade" />
      <front-page-design-nav theme="transparent" />

      <section class="hero">
        <img :src="logo" alt="BOX21" class="hero__logo" />
        <h1>
          <em>{{ hero.line1 }}</em>
          {{ hero.line2 }}
          <span>{{ hero.line3 }}</span>
        </h1>
        <p>{{ hero.tagline }}</p>
        <button type="button" class="hero__cta" @click="goToRegister">Explore the platform</button>
      </section>
    </div>

    <section class="flow">
      <div v-for="(pillar, i) in pillars" :key="pillar.id" class="flow__step">
        <div class="flow__num">{{ i + 1 }}</div>
        <img :src="pillar.icon" :alt="pillar.title" />
        <h3>{{ pillar.title }}</h3>
        <p>{{ pillar.tags.join(' · ') }}</p>
      </div>
    </section>

    <section class="gallery">
      <figure v-for="item in showcase" :key="item.id">
        <img :src="item.image" :alt="item.title" />
        <figcaption>
          <strong>{{ item.title }}</strong>
          {{ item.text }}
        </figcaption>
      </figure>
    </section>

    <front-page-design-footer theme="light" />
  </div>
</template>

<script>
import FrontPageDesignNav from '@/components/front_page/designs/FrontPageDesignNav.vue'
import FrontPageDesignFooter from '@/components/front_page/designs/FrontPageDesignFooter.vue'
import { BRAND, HERO, PILLARS, SHOWCASE, HERO_IMAGE } from '@/components/front_page/designs/shared'

export default {
  name: 'DesignNature',
  components: { FrontPageDesignNav, FrontPageDesignFooter },
  data() {
    return {
      logo: BRAND.logo,
      hero: HERO,
      pillars: PILLARS,
      showcase: SHOWCASE,
      heroImage: HERO_IMAGE,
    }
  },
  methods: {
    goToRegister() { this.$router.push({ path: '/login', query: { tab: 'register' } }) },
  },
}
</script>

<style scoped>
.design-nature {
  min-height: 100vh;
  background: #2c3e2a;
  color: #f5f0e8;
  font-family: Georgia, 'Times New Roman', serif;
}

.hero-wrap {
  position: relative;
  min-height: 75vh;
  overflow: hidden;
}

.hero-wrap__bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-wrap__shade {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(20, 40, 30, 0.5) 0%, rgba(20, 40, 30, 0.85) 100%);
}

.hero {
  position: relative;
  z-index: 2;
  max-width: 680px;
  padding: 140px 24px 80px;
  margin: 0 auto;
  text-align: center;
}

.hero__logo {
  height: 48px;
  filter: brightness(0) invert(1);
  margin-bottom: 36px;
}

.hero h1 {
  font-size: clamp(1.75rem, 4vw, 2.75rem);
  font-weight: 400;
  line-height: 1.35;
  margin: 0 0 20px;
}

.hero h1 em {
  font-style: italic;
  color: #a8d4f0;
}

.hero h1 span {
  display: block;
  color: #7bacd6;
  font-weight: 700;
}

.hero p {
  font-family: system-ui, sans-serif;
  font-size: 1.05rem;
  line-height: 1.7;
  opacity: 0.9;
  margin: 0 0 32px;
}

.hero__cta {
  font-family: system-ui, sans-serif;
  background: #0677b9;
  color: #fff;
  border: none;
  padding: 14px 32px;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  letter-spacing: 0.02em;
}

.flow {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 32px;
  padding: 64px 24px;
  background: #f5f0e8;
  color: #2c3e2a;
}

.flow__step {
  text-align: center;
  max-width: 200px;
  font-family: system-ui, sans-serif;
}

.flow__num {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #0677b9;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  margin: 0 auto 16px;
}

.flow__step img {
  width: 40px;
  height: 40px;
  margin-bottom: 12px;
}

.flow__step h3 {
  font-size: 1rem;
  margin: 0 0 8px;
}

.flow__step p {
  font-size: 0.85rem;
  color: #666;
  margin: 0;
}

.gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  padding: 64px 24px;
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  color: #333;
  font-family: system-ui, sans-serif;
}

.gallery figure {
  margin: 0;
}

.gallery img {
  width: 100%;
  border-radius: 8px;
  aspect-ratio: 4/3;
  object-fit: cover;
}

.gallery figcaption {
  padding: 16px 0;
  font-size: 0.95rem;
  line-height: 1.5;
}

.gallery strong {
  display: block;
  margin-bottom: 6px;
  color: #0677b9;
}
</style>
